import React from "react";
import TicketManager from "./ticketManager";

const SampleTicket = () => {
  return (
    <div>
      <TicketManager ticketId="12345" />
    </div>
  );
};

export default SampleTicket;
